export default {
  preprocessingLoader: {
    title: 'ジオメトリを確認中',
    message:
      'メッシュ生成前にヘルスチェックを実行します。通常は1分ほどで完了します。',
  },
  sectionShell: {
    noData: 'データがありません',
  },
  studyHeader: {
    backToStudies: 'スタディ一覧に戻る',
    backToEvaluations: '評価一覧に戻る',
    studyNameLabel: 'スタディ名',
    renameTooltip: 'クリックしてスタディ名を変更',
    renameFailed: '名前の変更に失敗しました',
    saving: '保存中...',
    saveFailed: '保存に失敗しました',
    lastSaved: '最終保存 {{time}}',
    dpsReady: '{{total}} 件中 {{done}} 件の設計点が準備完了',
    modeOverview: '概要',
    modePoints: '設計点',
    modeCompare: '比較',
    modeLabel: '結果ビュー',
    densityTrigger: '表示密度',
    densityLabel: '表示密度',
    density_comfortable: 'ゆったり',
    densityHint_comfortable: 'パネルごとにカード表示、間に余白を取ります',
    density_compact: '高密度',
    densityHint_compact: '罫線で区切った一枚の表 — 画面に最も多く表示します',
    phaseMesh: 'メッシュ',
    phaseSimulate: '解析',
    phaseAnalyze: '結果',
    journeyLabel: 'スタディの進捗',
    writeup: 'レポート',
  },
  studyKind: {
    heading: 'スタディ手法',
    changeTooltip: 'スタディ手法を変更',
    fixedTooltip:
      'スタディ開始後は手法が固定されます。別の手法を試すには複製してください',
    comingSoon: '近日公開',
    changeError: '手法を変更できませんでした。もう一度お試しください。',
    options: {
      doe: {
        label: 'DOE',
        subtitle: 'すべての組み合わせを実行',
      },
      surrogate: {
        label: 'サロゲート',
        subtitle: '高速な予測モデルを学習',
      },
      gci: {
        label: 'GCI',
        subtitle: 'メッシュ独立性スタディ',
      },
    },
  },
  solver: {
    incompressible: 'OpenFOAM — {{flow}} 非圧縮性',
    unknownFlow: '不明',
    kinematicViscosity: '動粘度',
    inletVelocity: '入口速度',
    outletPressure: '出口圧力',
    turbulenceIntensity: '乱流強度',
    turbulentLengthScale: '乱流長さスケール',
    convergenceCriteria: '収束条件',
    solverSettings: 'ソルバー設定',
    advancedFold: '詳細設定を表示',
    default: 'デフォルト',
    inletBoundaryConditions: '入口・境界条件',
    axisInlet: '{{axis}} 入口',
    axisLabel: '{{axis}} 軸',
    bc: {
      velocityInlet: '速度入口',
      pressureOutlet: '圧力出口',
      wallNoSlip: '壁面（ノースリップ）',
      slip: 'スリップ',
      symmetry: '対称',
      freestream: '自由流',
    },
  },
  cht: {
    roleFluid: '流体',
    roleSolid: '固体',
    inletTemperature: '入口温度',
    regions: 'リージョン（{{count}}）',
    boundaryConditions: '境界条件（{{count}}）',
    bcFixedTemperature: '固定 T = {{value}} K',
    bcConvection: '対流: h = {{h}} W/(m²·K)、T∞ = {{tAmbient}} K',
    bcHeatSource: '体積熱源: {{value}} W/m³',
    bcHeatFlux: '熱流束: {{flux}} W/m²',
    regionHeatSource: '発熱源',
    propertyCurves: {
      modeConstant: '一定',
      modeCurve: '温度依存',
      modeAria: '{{property}} の温度に対する扱い',
      caseSheetTitle: '物性設定',
      caseSheetValue: '値 / 範囲',
      caseSheetMode: 'モード',
      chipCurve: '曲線',
      chipConstant: '一定',
      recommendCurve: '推奨: 曲線',
      recommendConstant: '推奨: 一定',
      chartDescription:
        '{{lowTemperature}} °C から {{highTemperature}} °C の範囲で {{low}} から {{high}} {{unit}} へ変化します。',
      inspectorTitle: '{{property}} と温度の関係',
      inspectorClose: '曲線インスペクターを閉じる',
      expectedRange: '想定温度範囲',
      expectedRangeLow: '最低温度',
      expectedRangeHigh: '最高温度',
      // 「下の」は、ランキングがこのフィールドの下のインライン折りたたみ
      // だった頃の記述です。現在はパネル横のオーバーレイです。
      expectedRangeHint:
        'どの物性を曲線として推奨するかを決めます。概要を参照してください。',
      expectedRangeDrag: '上限をドラッグ',
      expectedRangeMinSpan:
        '両端の差を {{span}} °C 以上に保つため引き上げました。',
      clamped: '曲線の端で頭打ち',
      clampedTipHigh:
        'このテーブルは {{limit}} °C までです。それより上ではソルバーは傾向を延長せず最後の値を保持し、実際の計算も同じ挙動になります。',
      clampedTipLow:
        'このテーブルは {{limit}} °C からです。それより下ではソルバーは傾向を延長せず最初の値を保持し、実際の計算も同じ挙動になります。',
      sensitivity: '感度',
      sensitivityHint:
        '想定範囲全体で物性値がどれだけ動くかを、小さい方の端の値に対する比で示します。{{threshold}} % を超える場合は一定値ではなく曲線で追う価値があります。',
      sensitivityUnavailable: '測定不可',
      accuracy: '直線補間の誤差は元データの {{percent}} % 以内',
      source: '出典: {{source}}',
      unverified: '未検証',
      unverifiedTip:
        'これらの数値は出典から転記されましたが、二重確認は行われていません。この表示はスタディに保存され、レポートにも表示されます。',
      constantsOnly: '一定値のみ',
      noCurveReason: '曲線なし: {{reason}}',
      curveUnavailable: 'まだ曲線サンプルがありません',
      curveFailed: '現在、曲線を取得できません',
      curveWindowRefused: '範囲がデータの範囲外です',
      constantFarFromReference:
        '境界温度がこの流体の基準 {{refC}} °C から約 {{delta}} K 離れていますが、一部の物性がまだ定数です。温度に追従するよう曲線に切り替えてください。',
      curveGridLocked:
        'この領域には既に {{existing}} の曲線があり、この物性のサンプルは {{offered}} です。1 つの領域内のすべての曲線は同一の温度グリッドを共有する必要があるため（ソルバーは密度と粘度を点ごとに掛け合わせます）、これは追加できません。先にインポート済みの曲線を「一定」に戻すか、この温度で再インポートしてください。',
      overview: '概要',
      overviewTitle: 'このケースで変化するもの',
      overviewClose: '概要を閉じる',
      rankingTitle: '温度感度',
      rankingEmpty: 'この材料には曲線データがありません。',
      rankingProperty: '物性',
      rankingRange: '{{low}} °C → {{high}} °C',
      excursion: 'その端を {{kelvin}} K 超えました。',
      importTitle: '{{property}} の実測値を取り込む',
      importOpen: '{{property}} の実測データを取り込む',
      importReplace: '{{property}} を実測データで置き換える',
      importHint:
        '2 列の CSV：温度、次に値。ケースに載せる前にここで確認できます。',
      importExample: 'ファイルの書式',
      importExampleUnit: '温度は下で選んだ単位、{{property}} は {{unit}}。',
      importRuleColumns: '列はちょうど 2 つ、カンマ区切り。',
      importRuleSemicolon:
        'セミコロン区切りは受け付けません。カンマ区切り・小数点で書き出し直してください。',
      importRuleHeading:
        'ヘッダー行は 1 行のみ、# コメントを除く最初の行だけ。それ以降の非数値行はエラーです。',
      importRulePoints: '精度チェックのため 5 行以上必要です。',
      importRuleSkipped: '空行と # で始まる行は読み飛ばします。',
      importRuleExcel: 'Excel の「CSV UTF-8」書き出しにも対応します。',
      importTemplate: 'テンプレートをダウンロード',
      importFile: 'CSV ファイルを選択',
      importPaste: 'または行を貼り付け',
      importUnit: '温度列の単位',
      importLabel: 'このデータの名前',
      importLabelPlaceholder: '例：ACME 40/60、データシート rev C',
      importLabelHint:
        '本日の日付とともに曲線の出典になります。取り込んだ曲線の出典情報はこれだけで、レポートにも印字されます。',
      importCheck: 'ファイルを確認',
      importAccepted: '{{rows}} 行を受け付けました。',
      importReordered: '温度順が乱れていたため並べ替えました。',
      importGridClash:
        'この領域の他の曲線は {{existing}}、このファイルは {{incoming}} です。1 つの領域内のすべての曲線は同一の温度格子を共有する必要があります（ソルバーが密度×粘度を点ごとに読むため）。他を先に定数へ戻すか、このファイルを同じ温度で再出力してください。',
      importChecking: 'ファイルを確認中…',
      importAccuracy:
        '点の間を直線で読むと、点が示す曲線から最大 {{percent}} % ずれます',
      importTooBig:
        'そのファイルは {{chars}} 文字で、上限の {{limit}} を超えています。物性曲線は数十行程度です。この大きさは通常、表計算全体の書き出しです。',
      importUseConstant: 'この値を使う',
      importIsConstant: '温度のない値が 1 つ。定数として保存します。',
      importTooFewRows:
        '曲線には最低 {{min}} 行必要です。これを下回ると、実際には数 % ずれている曲線でも精度確認が 0 % と報告してしまいます。定数はちょうど 1 つの値です。このファイルは {{rows}} 行です。',
      importNotPositive:
        '物性値は 0 より大きい必要があります。このファイルの値は {{value}} です。',
      importConstantHasTemperature:
        '1 行だけのファイルには値のみを入れてください。温度は入れられません。定数はあらゆる温度に適用されるため、温度の置き場所がありません。',
      importUse: 'この曲線を使う',
      importCancel: '破棄',
      importFailed:
        'ファイルを処理できませんでした。データではなく当方の問題です。再試行してください。',
      importReadFailed: 'そのファイルを読み込めませんでした。',
      solvedBand: '計算された温度範囲',
      solvedBandTip:
        'この計算が実際に到達した温度は {{low}} - {{high}} °C です。設定パネルが示したのは想定範囲で、ここに示すのは実際の結果です。',
    },
  },
} as const;
